export default "__VITE_ASSET__Bat7Df3f__"